import React from "react";
import FormButtonStyle4 from "../../UIElements/FormButton";
import callApi from "../../../../utility/apiCaller";
import { useSelector } from "react-redux";

async function withRetry(fn, retries = 2, delay = 2000) {
  let attempt = 0;
  while (attempt <= retries) {
    try {
      return await fn();
    } catch (err) {
      if (attempt === retries) throw err;
      console.warn(`Retrying... attempt ${attempt + 1} failed`);
      await new Promise((r) => setTimeout(r, delay * (attempt + 1)));
      attempt++;
    }
  }
}

export default function AccountAggregator({ setCurrentStep }) {
  const user = useSelector((state) => state.app.user);
  const aaSlice = useSelector((state) => state?.aa);
  let leadId = aaSlice?.internalLeadId;
  let aaUrl = aaSlice.aaUrl

  const handleNext = async () => {
    try {
      const updateResponse = await withRetry(() =>
        callApi(
          `v1/lead/${leadId}/update-lead-new`,
          "post",
          {
            lead: {
              is_acc_aggregator_completed: true,
              steps_completed: 4,
            },
          },
          "core",
          user?.token ||
            "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2NjA2YWIzNmE1NjE2MjFkNGZiYTllODEiLCJjb250YWN0X25hbWUiOiJNdWt1bCBTaGFybWEiLCJjb3VudHJ5X2NvZGUiOiI5MSIsInBhbmNhcmQiOiJPTFRQUzEyNTVSIiwiY29udGFjdF9waG9uZSI6Ijk2MzQxMDkzNDkiLCJpYXQiOjE3MTE3MTMwNzh9.a0hEtlBumS9YJ9vd0arGJk1feNZjxQ-CwSWx6KcU8ks"
        )
      );
      //console.log(updateResponse);
      // setCurrentStep((prev) => prev + 1);
      if(aaUrl){
        window.location.href = aaUrl
      }else{
        setCurrentStep((prev) => prev + 1);
      }
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <div className="max-w-[400px] min-h-[100dvh] scroll-smooth font-atkinson w-[100vw] overflow-hidden mx-auto bg-white  flex flex-col justify-between">
      {/* Top Section */}
      <div>
        {/* Logo Row */}
        <div className="flex justify-between items-center p-4">
          <img
            src="/assets/img/Footer logo.png"
            alt="digitmoney logo"
            className="h-[17px] w-[100px]"
          />
          <img
            src="/assets/img/dmiicon.png"
            alt="DMI Finance logo"
            className="h-[32px] w-[123px]"
          />
        </div>

        {/* Title */}
        <div className="px-4">
          <h2 className="font-atkinson-bold text-[20px] text-gray-800">
            Account Aggregator
          </h2>
        </div>

        {/* Banner Card */}
        <div className="bg-gradient-to-r min-h-[165px] from-[#004739] to-[#12F280] rounded-[20px] mx-auto w-[90%] mt-4 relative p-4  z-0">
          {/* Lock Image */}
          <img
            src="/assets/img/lockgreen.png"
            alt="Lock Icon"
            className="absolute -right-1 -top-6 w-[172px] h-[193px] z-10"
          />
          {/* Bubble Images */}
          <img
            src="/assets/img/bubble.png"
            alt="Bubble 1"
            className="absolute w-[165px] h-[184px] top-0 right-1 z-20"
          />

          <div className="relative z-20 text-white">
            <h3 className=" text-[24px] font-bomstad-semibold leading-[1] text-[#FFFFFF]">
              last step <br /> to unlock your
              <br /> offer!
            </h3>
            <p className="text-[13px] leading-[1] mt-1 font-atkinson text-[#12F280]">
              Provide access to your
              <br /> bank statement via OTP
              <br /> in the next steps
            </p>
          </div>
        </div>

        {/* How It Works */}
        <div className="mt-8 px-10 py-5 flex justify-center items-center flex-col w-[90%] mx-auto border shadow-sm rounded-[30px]">
          <p className="text-center text-gray-400 text-[20px] font-bold">
            HOW IT WORKS?
          </p>
          <div className="mt-6 space-y-6">
            <div className="flex items-center gap-3">
              <img
                src="/assets/img/nopaperwork.png"
                alt="Icon"
                className="w-[29px] h-[38px]"
              />
              <span className="text-gray-700 text-[18px]">
                No paperwork involved
              </span>
            </div>
            <div className="flex items-center gap-3">
              <img
                src="/assets/img/stopwatch.png"
                alt="Icon"
                className="w-[29px] h-[33px]"
              />
              <span className="text-gray-700 text-[18px]">
                Bank statement fetched automatically
              </span>
            </div>
            <div className="flex items-center gap-3">
              <img
                src="/assets/img/shield100.png"
                alt="Icon"
                className="w-[29px] h-[37px]"
              />
              <span className="text-gray-700 text-[18px]">
                100% safe and secure
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="mt-8 ">
        {/* Footer Logos */}
        <div className="text-center text-xs text-gray-500">
          <img
            src="/assets/img/Footer logo.png"
            alt="digitmoney small logo"
            className="mx-auto h-4 mb-1"
          />
          Lending Partner{" "}
          <img
            src="/assets/img/dmiicon.png"
            alt="DMI Finance small"
            className="inline h-4 ml-1"
          />
        </div>

        {/* Button */}

        <div className="mt-4 mb-4 ">
          <FormButtonStyle4 text="Next" onClick={handleNext} />
        </div>
      </div>
    </div>
  );
}
